import '../../scss/models-show.scss';

import '../common/viewer';
import { initSeeMore } from '../common/seeMoreResultInfiniteScroll';
import imgLazyload from '../common/imgLazyload';
import {initFilters} from "../collection/filters";
import '../common/photoSizeControl';
import '../common/stickySearch';
import {createPaywall} from "../common/paywall";
import {initMoodboardQuicksaveIfConnected} from "../moodboard_quicksave";

const filtersBlock = document.querySelector('.filters-block');
const navigation = document.querySelector('.navigation');

initFilters();

document.addEventListener('DOMContentLoaded', async () => {
    initFilters();
    initMoodboardQuicksaveIfConnected();

    const paywall = await createPaywall({
        authorizedPlans: ['all-included', 'student-special', 'trend-master'],
        context: 'models',
        onLock: () => {
            document.querySelector('#content')?.remove();
        }
    });

    if (!paywall) {
        initSeeMore(document.querySelector('#results'), false);

        let observer = new MutationObserver(mutations => {
            for (let mutation of mutations) {
                navigation.style.display = mutation.target.classList.contains('sticky') ? 'none' : 'flex';
            }
        });

        observer.observe(filtersBlock, {attributes: true});
    }

    document.addEventListener('nextResultsFetched', () => {
        imgLazyload();
    });
});
